import { CKColorVariants } from './getButtonVariant';

export const resolveColorCK = (color: CKColorVariants) => {
  switch (color) {
    case 'herb':
      return 'primary';
    case 'terracotta':
      return 'secondary';
    case 'stone':
      return 'tertiary';
    default:
      return 'primary';
  }
};

export default resolveColorCK;
